import { render, staticRenderFns } from "./ConfirmSummaryTemperature.vue?vue&type=template&id=1ba968dc&scoped=true&"
import script from "./ConfirmSummaryTemperature.vue?vue&type=script&lang=js&"
export * from "./ConfirmSummaryTemperature.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmSummaryTemperature.vue?vue&type=style&index=0&id=1ba968dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba968dc",
  null
  
)

export default component.exports